/**
 * Extract a named field from a GraphQL `data` payload (RTK Query base queries
 * type their result as `unknown`, so we narrow here in one place).
 */
export const pick = <T>(res: unknown, key: string): T =>
  (res as Record<string, T>)[key];
